<template>
  <div>
    <b-row class="mt-2">
      <b-col lg="3">
        <InputQuantity
          id="pIBSUF"
          label="Alíquota"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.pIBSUF"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.vIBSUF"
        />
      </b-col>
      <b-col lg="3">
        <InputQuantity
          id="IbsUfPDif"
          label="Alíquota diferimento"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.pDif"
          :precision="4"
          :returnFormattedValue="false"
          :disabled="!canEditDiferimento"
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor diferimento"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.vDif"
          :disabled="!canEditDiferimento"
        />
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="3">
        <InputMoney
          label="Valor devolução tributos"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.vDevTrib"
        />
      </b-col>
      <b-col lg="3">
        <InputQuantity
          id="IbsUfPRedAliq"
          label="Percentual redução de alíquota"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.pRedAliq"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3" class="mt-lg-4">
        <InputQuantity
          id="IbsUfPAliqEfet"
          label="Alíquota efetiva"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.pAliqEfet"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputMoney, InputQuantity } from '@/components/Form';

export default {
  name: 'IBSUF',
  components: {
    InputMoney,
    InputQuantity,
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
  },
  props: {
    canEditDiferimento: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
